export default function RightArrowIcon() {
	return (
		<svg
			width="21"
			height="31"
			viewBox="0 0 21 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_647_895)">
				<path
					d="M16.1052 10.2279L7.14689 1.26959C6.97984 1.10254 6.78152 0.970025 6.56326 0.879617C6.34499 0.789209 6.11106 0.742676 5.87481 0.742676C5.39769 0.742676 4.9401 0.932213 4.60273 1.26959C4.43567 1.43664 4.30316 1.63496 4.21275 1.85323C4.12234 2.07149 4.07581 2.30543 4.07581 2.54167C4.07581 3.0188 4.26535 3.47638 4.60273 3.81376L12.3069 11.5L4.60273 19.1863C4.4348 19.3528 4.30151 19.551 4.21055 19.7693C4.11959 19.9876 4.07275 20.2218 4.07275 20.4583C4.07275 20.6949 4.11959 20.929 4.21055 21.1474C4.30151 21.3657 4.4348 21.5639 4.60273 21.7304C4.76928 21.8984 4.96744 22.0316 5.18578 22.1226C5.40411 22.2136 5.63829 22.2604 5.87481 22.2604C6.11133 22.2604 6.34551 22.2136 6.56384 22.1226C6.78217 22.0316 6.98033 21.8984 7.14689 21.7304L16.1052 12.7721C16.2732 12.6055 16.4064 12.4074 16.4974 12.189C16.5884 11.9707 16.6352 11.7365 16.6352 11.5C16.6352 11.2635 16.5884 11.0293 16.4974 10.811C16.4064 10.5926 16.2732 10.3945 16.1052 10.2279Z"
					fill="#333333"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_647_895"
					x="0.0727539"
					y="0.742676"
					width="20.5625"
					height="29.5178"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_647_895"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_647_895"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
}
